<template>
    <NuxtLayout name="default" mainClass="inside_main">
        <div class="landing_wrapper business" id="business">

            <div class="hero">

                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-md-12">
                            <div class="section_title">
                                <h1>

                                    <span>
                                        <span class="typing">
                                            اجعل أﻋﻤﺎﻟﻚ ﺗﻨﻤﻮ و كُن قريب ﻣﻦ ﻋﻤﻼﺋﻚ
                                        </span>
                                        <img src="/website/assets/img/business/line-black.png" alt="">
                                    </span>

                                </h1>
                            </div>
                            <div class="sub_title">
                                <h3>
                                    ﺗﻘﻴﻴﻤﺎت ﻣﻮﺛﻮﻗﺔ وﺣﻘﻴﻘﻴﺔ ﻣﻦ ﻋﻤﻼﺋﻚُ ﺗﻈﻬﺮ ﺟﻮدة ﻋﻤﻠﻚ
                                </h3>
                            </div>
                            <div class="hero_buttons">
                                <a href="https://business.reviewapp.sa/register" class="hero_btn btn-register" target="_blank">

                                    ابدأ الآن


                                </a>

                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="image">
                                <img src="/website/assets/img/business/hero-img.png?v=1" alt="hero img"
                                    class="floating_img_none">
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="some-info" id="features">

                <div class="container">
                    <div class="info-item box_animation animate">
                        <div class="row align-items-center">
                            <div class="col-md-5">
                                <div class="info">
                                    <h3>
                                        تقييمات من أشخاص موثوقين
                                    </h3>
                                    <p>
                                        استمع لتقييمات موثوقة من مستخدمين حقيقيين ، اكتشف تجارب صادقة تعكس الواقع واستفد
                                        من توصياتهم لتحديد الخيارات الأفضل لك بكل ثقة
                                    </p>
                                    <div class="more-people">
                                        <span>المزيد من الأشخاص الموثوقين</span>
                                        <img src="/website/assets/img/business/more-people-new.png?version=1" alt="more people"
                                            draggable="false">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 offset-md-1">
                                <div class="image">
                                    <img src="/website/assets/img/business/trusted-people.png" alt="trusted people"
                                        draggable="false" class="floating_img_none">
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="info-item box_animation animate">
                        <div class="row align-items-center">

                            <div class="col-md-6">
                                <div class="image">
                                    <img src="/website/assets/img/business/people-rates.png?v=1" alt=""
                                        class="floating_img_none">
                                </div>
                            </div>

                            <div class="col-md-5 offset-md-1">
                                <div class="info">
                                    <h3>
                                        تواصل مع كاتب التقييم وأعرف أكثر
                                    </h3>
                                    <p>

                                        بكل سهولة تواصل مع عملائكم بعد تقييمهم و اعرف منهم أكثر حول تجربتهم و كون نظرة
                                        حقيقية و عن ما يشعر به عملائك عن تجاربهم لخدماتك و منتجاتك
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div class="info-item box_animation animate">
                        <div class="row align-items-center">

                            <div class="col-md-5">
                                <div class="info">
                                    <h3>
                                        أرسل دعوة لعملائك أطلب منهم التقييم
                                    </h3>
                                    <p>
                                        حفّز عملاءك على مشاركة آرائهم بإرسال دعوة مخصصة للتقييم ، اجمع ملاحظاتهم لتحسين
                                        خدماتك وتلبية احتياجاتهم بشكل أفضل وبناء علاقات قوية ومستدامة
                                    </p>
                                </div>
                            </div>

                            <div class="col-md-6 offset-md-1">
                                <div class="image">
                                    <img src="/website/assets/img/business/message-rate.png?v=1" alt=""
                                        class="floating_img_none">
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="info-item box_animation animate">
                        <div class="row align-items-center">

                            <div class="col-md-6">
                                <div class="image">
                                    <img src="/website/assets/img/business/all_rates.png?v=1.1" alt=""
                                        class="floating_img_none">
                                </div>
                            </div>

                            <div class="col-md-5 offset-md-1">
                                <div class="info">
                                    <h3>
                                        تقييمات عملائك في مكان واحد
                                    </h3>
                                    <p>
                                        جميع تقييمات عملائك اجعلها في منصة واحدة لسهولة التحليل و استعراض الآراء بوضوح
                                        واستخدمها لتعزيز جودة خدماتك و منتجاتك وزيادة ثقة العملاء
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="info-item box_animation animate">
                        <div class="row align-items-center">



                            <div class="col-md-5">
                                <div class="info">
                                    <h3>
                                        تقارير و إحصائيات تصنع القرار
                                    </h3>
                                    <p>
                                        استخدم تقارير وإحصائيات شاملة تساعدك في اتخاذ قرارات مبنية على بيانات حقيقية
                                        راقب التحليلات المتعمقة لتوجيه أعمالك نحو النجاح والتميز
                                    </p>
                                </div>
                            </div>

                            <div class="col-md-6 offset-md-1">
                                <div class="image">
                                    <img src="/website/assets/img/business/reports-statics.png?v=1" alt=""
                                        class="floating_img_none">
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="info-item box_animation animate">
                        <div class="row align-items-center">




                            <div class="col-md-6">
                                <div class="image">
                                    <img src="/website/assets/img/business/link-platform.png?v=1" alt=""
                                        class="floating_img_none">
                                </div>
                            </div>

                            <div class="col-md-5 offset-md-1">
                                <div class="info">
                                    <h3>
                                        اربط بسهولة مع أدواتك الحالية
                                    </h3>
                                    <p>
                                        اجعل اعمالك متكاملة بسهولة مع أدواتك الحالية للحصول على تجربة متوافقة توفر لك
                                        الوقت وتعزز كفاءة العمل بشكل فعّال
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="info-item box_animation animate">
                        <div class="row align-items-center">
                            <div class="col-md-5">
                                <div class="info">
                                    <h3>
                                        تحكم بصفحة أعمالك
                                    </h3>
                                    <p>
                                        تحكم بصفحة أعمالك لتظهر بأفضل شكل أمام عملائك ، قم بتحديث المحتوى ، والتفاعل مع
                                        العملاء ، وتعزيز التواصل معهم بشكل مباشر ومبسط
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 offset-md-1">
                                <div class="image">
                                    <img src="/website/assets/img/business/wokrs-page.png" alt=""
                                        class="floating_img_none">
                                </div>
                            </div>
                        </div>
                    </div>



                </div>

            </div>


            
            <div class="business-packages" id="business-packages">
                <div class="container">
                    <div class="section_title">
                        <h1>
                           إختر الباقة المناسبة لك 
                        </h1>
                        <div class="line">
                            <svg xmlns="http://www.w3.org/2000/svg" width="224.364" height="98.148"
                                viewBox="0 0 224.364 98.148">
                                <path id="Vector_1" data-name="Vector 1"
                                    d="M5.328,57.858C30.2,43.947,106.714,13.9,213.786,5"
                                    transform="matrix(0.985, 0.174, -0.174, 0.985, 10.318, -1.302)" fill="none"
                                    stroke="#000" stroke-linecap="round" stroke-width="7" />
                            </svg>

                        </div>
                        <div class="pp-switch mt-3 mb-4 large">
                            <label :class="['toggler', isMonthly ? 'toggler--is-active' : '']" @click="setMonthly(true)">
                                الشهرية
                            </label>

                            <div :class="['toggle', !isMonthly ? 'active' : '']">
                                <input type="checkbox" id="switcher" class="check" :checked="!isMonthly" @click="toggleView" />
                                <b class="b switch"></b>
                            </div>

                            <label :class="['toggler', !isMonthly ? 'toggler--is-active' : '']" @click="setMonthly(false)">
                                السنوية
                                <span class="percentge-dicount">وفر 16 % مع الباقات السنوية</span>
                            </label>
                        </div>
                         <span class="percentge-dicount mobile">وفر 16 % مع الباقات السنوية</span>
                    </div>
                  
                    

                    <div class="pricing-container">
                        <!-- Basic Plan -->
                        <div class="pricing-card">

                            <h2 class="plan-name">المجانية</h2>
                            <div class="price">
                            مجاناً
                            </div>
                            <ul class="plan-features free">
                            <li>عدد تقييمات 10</li>
                            <li>ارسال حملات الواتساب</li>
                            <li>تقارير تفصيلية</li>
                            <li>عدد فروع لا محدود</li>
                            <li>انشاء حسابات لفريق العمل بعدد 1</li>
                            <li>الحصول على التحديثات بشكل مجاني طوال فترة الاشتراك</li>
                            </ul>
                            <button class="cta-button">إشترك الآن</button>
                        </div>

                        <div class="pricing-card">

                            <h2 class="plan-name">الاحترافية</h2>
                            <div class="price" :class="{ hide: !isMonthly }" id="monthly">
                            99
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39"
                                width="35">
                                <path class="cls-1"
                                d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
                                <path class="cls-1"
                                d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
                            </svg>
                             <span class="vat">
                              + VAT
                            </span>
                            </div>

                            <div class="price" :class="{ hide: isMonthly }" id="yearly">
                            <span class="discountPrice">
                                1200
                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 1124.14 1256.39" width="15">
                                <path class="cls-1"
                                    d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
                                <path class="cls-1"
                                    d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
                                </svg>
                            </span>
                            999
                            
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39"
                                width="35">
                                <path class="cls-1"
                                d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
                                <path class="cls-1"
                                d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
                            </svg>
                             <span class="vat">
                              + VAT
                            </span>
                            </div>

                            <ul class="plan-features paid">
                            <li>عدد تقييمات</li>
                            <li>ارسال حملات الواتساب</li>
                            <li>تقارير تفصيلية</li>
                            <li>عدد فروع بعدد 10</li>
                            <li>انشاء حسابات لفريق العمل بعدد 10</li>
                            <li>الحصول على التحديثات بشكل مجاني طوال فترة الاشتراك</li>
                            </ul>
                            <button class="cta-button">إشترك الآن</button>
                        </div>

                        </div>
                        <NuxtLink to="/pricing" class="compare-package-btn">
                    قارن بين الباقات
                </NuxtLink>
                </div>

                 

            </div>

            <div class="clients_rates">
                <div class="container">
                    <div class="section_title">
                        <h1>
                            لماذا يجب عليك الاهتمام بتقييمات عملائك ؟
                        </h1>
                        <div class="line">
                            <svg xmlns="http://www.w3.org/2000/svg" width="224.364" height="98.148"
                                viewBox="0 0 224.364 98.148">
                                <path id="Vector_1" data-name="Vector 1"
                                    d="M5.328,57.858C30.2,43.947,106.714,13.9,213.786,5"
                                    transform="matrix(0.985, 0.174, -0.174, 0.985, 10.318, -1.302)" fill="none"
                                    stroke="#000" stroke-linecap="round" stroke-width="7" />
                            </svg>

                        </div>
                    </div>

                    <div class="row box_animation">
                        <div class="col-md-4">
                            <div class="item">
                                <div class="icon bg-1">
                                    <img src="/website/assets/img/business/sack-dollar.png" alt="">
                                </div>
                                <div class="num">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28.374" height="19.571"
                                        viewBox="0 0 28.374 19.571">
                                        <g id="Group_94781" data-name="Group 94781" transform="translate(0 0)">
                                            <path id="Path_123795" data-name="Path 123795"
                                                d="M468.978,172.579c-1.539,1.543-3.01,3.017-4.485,4.494q-1.889,1.892-3.782,3.778a1.473,1.473,0,0,1-2.49-.755,1.445,1.445,0,0,1,.471-1.382q2.623-2.623,5.243-5.245,1.941-1.942,3.887-3.881a1.455,1.455,0,0,1,2.241-.012q1.476,1.455,2.932,2.932a2.42,2.42,0,0,1,.256.378l8.176-8.183c-.117-.006-.229-.019-.342-.019-.945,0-1.892.01-2.837-.006a1.423,1.423,0,0,1-1.353-.881,1.38,1.38,0,0,1,.217-1.533,1.437,1.437,0,0,1,1.147-.538c2.263-.006,4.533-.01,6.8,0a1.473,1.473,0,0,1,1.492,1.51q.012,3.382,0,6.767a1.493,1.493,0,0,1-1.484,1.521,1.473,1.473,0,0,1-1.455-1.508c-.014-.922,0-1.844,0-2.765v-.382l-.132-.085a3.044,3.044,0,0,1-.276.369q-4.343,4.352-8.692,8.694a1.478,1.478,0,0,1-2.321.008q-1.482-1.476-2.955-2.957C469.151,172.814,469.083,172.709,468.978,172.579Z"
                                                transform="translate(-458.188 -161.722)" fill="#00ce02" />
                                        </g>
                                    </svg>

                                    <span>18</span>%
                                </div>
                                <p>
                                    نسبة زيادة في المبيعات
                                </p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="item">
                                <div class="icon bg-2">
                                    <img src="/website/assets/img/business/card.png" alt="">
                                </div>
                                <div class="num">
                                    <span>89</span>%
                                </div>
                                <p>
                                    من المستخدمين يقررون الشراء
                                    <br>
                                    بناءا على التقييم

                                </p>

                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="item">
                                <div class="icon bg-3">
                                    <img src="/website/assets/img/business/money-recive.png" alt="">
                                </div>
                                <div class="num">
                                    <span>70</span>%
                                </div>
                                <p>

                                    من الأشخاص يقرؤون التقييمات
                                    <br>
                                    قبل الشراء
                                </p>

                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div class="how-to-rate">

                <div class="container">


                    <div class="section_title box_animation">
                        <h1>تقييم عميلك أصبح أسهل </h1>
                        <div class="line">
                            <svg xmlns="http://www.w3.org/2000/svg" width="224.364" height="98.148"
                                viewBox="0 0 224.364 98.148">
                                <path id="Vector_1" data-name="Vector 1"
                                    d="M5.328,57.858C30.2,43.947,106.714,13.9,213.786,5"
                                    transform="matrix(0.985, 0.174, -0.174, 0.985, 10.318, -1.302)" fill="none"
                                    stroke="#000" stroke-linecap="round" stroke-width="7" />
                            </svg>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <div class="item">
                                <p>أظهر لعملائك نتيجة تقييمك بشهادة من رفيو </p>
                                <div class="image">
                                    <img src="/website/assets/img/business/rate-1.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="item">
                                <p>استخدم ستاند في فروعك بتنقية NFC </p>
                                <div class="image">
                                    <img src="/website/assets/img/business/rate-2.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="item">
                                <p>بطاقات يتم توزيعها لعملائك مع الطلب </p>
                                <div class="image">
                                    <img src="/website/assets/img/business/rate-3.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="item">
                                <p>ملصقات توضع على ( أكياس ، كراتين ) الطلبات </p>
                                <div class="image">
                                    <img src="/website/assets/img/business/rate--4.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="item">
                                <p>أنشئ عدد لا نهائي من الــQR و خصص احتياجك </p>
                                <div class="image">
                                    <img src="/website/assets/img/business/rate--5.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="item">
                                <p>اعرض التقييمات في موقعك أو تطبيقك </p>
                                <div class="image">
                                    <img src="/website/assets/img/business/rate-6.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

            </div>


            <div class="create-business">
                <div class="container">
                    <div class="create-business-card">
                        <div>
                            <h2>امتلك موقعك الان</h2>
                            <p>
                                أنشئ موقعك الآن بأدوات مرنة و حلول متكاملة تساعدك في اتخاذ قرارات شراء مدروسة بناءً على آراء موثوقة
                            </p>
                        </div>
                        <a href="https://business.reviewapp.sa/register" class="hero_btn btn-register" target="_blank"> ابدأ الآن </a>
                    </div>
                </div>
            </div>


        </div>
    </NuxtLayout>
</template>

<script setup lang="ts">
// You can add stores or composables here if needed
// For example:
// import { useWebsiteStore } from '~/store/website'
// const websiteStore = useWebsiteStore()
import { onMounted } from 'vue';
useHead({
    title: 'للأعمال',
        meta: [
        { property: 'og:title', content: `للأعمال | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
        { property: 'twitter:title', content: `للأعمال | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
    ],
  script: [
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.9.1/gsap.min.js",
      defer: true
    },
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.9.1/ScrollTrigger.min.js",
      defer: true
    }
  ]
});


onMounted(() => {
  // Wait for GSAP to be loaded before running animations
  const checkGSAP = setInterval(() => {
    if (window.gsap && window.ScrollTrigger) {
      clearInterval(checkGSAP);
      gsap.registerPlugin(ScrollTrigger);

      // Animate elements with .box_animation class
      gsap.utils.toArray('.box_animation').forEach((box) => {
        gsap.fromTo(box, {
          opacity: 0,
          y: 100
        }, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power4.out',
          scrollTrigger: {
            trigger: box,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          }
        });
      });

      // Counter animation function
      function animateCounter(element, start, end, duration) {
        gsap.fromTo(element, {
          textContent: start
        }, {
          textContent: end,
          duration: duration,
          ease: "power1.inOut",
          snap: { textContent: 1 },
          onUpdate: function() {
            element.textContent = Math.ceil(element.textContent);
          }
        });
      }

      // Apply counter animation to each .num > span
      document.querySelectorAll('.num > span').forEach((num) => {
        let endValue = parseFloat(num.textContent.replace(/[^0-9.-]+/g, ""));
        ScrollTrigger.create({
          trigger: num,
          start: "top 90%",
          onEnter: function() {
            animateCounter(num, 0, endValue, 2);
          },
          once: true // Ensures it only animates once
        });
      });

    }
  }, 100);


  const typingElements = document.querySelectorAll('.hero .typing');

    typingElements.forEach((element) => {
        const text = element.textContent.trim();
        const imgElement = element.nextElementSibling; // Image right after text

        // Hide the image initially
        if (imgElement && imgElement.tagName.toLowerCase() === 'img') {
            imgElement.style.visibility = 'hidden';
        }

        function typeText(index) {
            if (index < text.length) {
            element.textContent = text.slice(0, index + 1);
            setTimeout(() => typeText(index + 1), 100); // Adjust typing speed
            } else {
            // Show image after typing
            if (imgElement) imgElement.style.visibility = 'visible';

            // Pause before restarting
            setTimeout(() => {
                element.textContent = '';
                if (imgElement) imgElement.style.visibility = 'hidden';

                setTimeout(() => typeText(0), 500); // Restart typing effect
            }, 2000);
            }
        }

        // Start typing effect
        element.textContent = '';
        typeText(0);
    });

});



// Track if monthly is selected
const isMonthly = ref(true)

const setMonthly = (value) => {
  isMonthly.value = value
}

const toggleView = () => {
  isMonthly.value = !isMonthly.value
}
</script>

<style scoped>
    @import url("~/assets/css/landingStyles.css");
.hide {
  display: none !important;
}
</style>